export default "__VITE_ASSET__BxEJUGWV__"